export const MENU_TRADE_SUMMARY = [
  { name: 'Dashboard', url: '/tradesummary/dashboard', icon: 'flaticon-analytics', hasSubMenu: false, exactMenu: true, isAllowed: true },
  { name: 'Reports', url: '/tradesummary/reports', icon: 'flaticon-interface-3', hasSubMenu: false, exactMenu: true, isAllowed: true },
  { name: 'Summary', url: '/tradesummary/summary', icon: 'flaticon2-line-chart', hasSubMenu: false, exactMenu: true, isAllowed: true },
  {
    name: 'Maintenance', url: '/tradesummary/maintenance', icon: 'bi bi-gear', hasSubMenu: true,
    submenu: [
      { name: 'Trade Position Product Mapping', url: `/tradesummary/maintenance/reportproductmapping`, isAllowed: true }
    ]
  },
]